/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Protocol/Form
 * @desc Filter Protocol form
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ParamsStateContextProvider } from 'labstep-web/contexts/params-state';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import { PostFilterProtocol } from 'labstep-web/services/postFilter/filters/protocol';
import type React from 'react';
import type { IFilterPostNewIndexProtocolFormProps } from './types';

const FilterPostNewIndexProtocolForm: React.FC<
  IFilterPostNewIndexProtocolFormProps
> = ({ addPostFilter, onDone, activeGroup }) => {
  if (!activeGroup) {
    return null;
  }

  return (
    <ParamsStateContextProvider value={{}}>
      <SearchSelect
        entityName={ProtocolCollection.entityName}
        isClearable
        params={{
          group_id: activeGroup?.id,
          has_last_version: true,
        }}
        onChange={(selectedOption) => {
          if (
            addPostFilter &&
            selectedOption &&
            selectedOption.last_version
          ) {
            addPostFilter(
              PostFilterProtocol.getNode([
                selectedOption.last_version.guid,
              ]),
            );
          }
          onDone();
        }}
      />
    </ParamsStateContextProvider>
  );
};

export default withActiveGroup(FilterPostNewIndexProtocolForm);
